import { includes } from 'lodash';
import { ReactNode, useMemo, useState } from 'react';
import { Button, Col, Dropdown, Row } from 'react-bootstrap';
import { BsChevronDown, BsFilter } from 'react-icons/bs';
import { SIZE_LG, useBreakpoint } from '../../hooks/breakpoint';
import { MobileFilterDropDown } from './MobileFilterDropDown';

export const FilterDropdown = ({
  children,
  isDirty,
  onClear,
  onApply,
  onToggle,
  filtersCount,
}: {
  children: ReactNode;
  isDirty: boolean;
  onClear: () => void;
  onApply: () => void;
  onToggle: () => void;
  filtersCount?: number;
}) => {
  const [show, setShow] = useState(false);
  const breakpoint = useBreakpoint();
  const showModal = useMemo(() => !includes(breakpoint, SIZE_LG), [breakpoint]);

  const clearHandler = () => {
    onClear();
  };

  const applyHandler = () => {
    onApply();
    setShow(false);
  };

  const onHideHandler = (res: boolean) => {
    if (res) {
      return applyHandler();
    }

    toggleHandler(null, null);
  };

  const toggleHandler = (_, meta) => {
    if (meta) {
      const target = meta.originalEvent.target as HTMLElement;

      if (target.classList.contains('select-input__option')) {
        return;
      }
    }

    onToggle();

    setShow(!show);
  };

  const showClearButton = isDirty || (filtersCount ?? 0) > 0; // Show clear if there are active filters

  return (
    <>
      {!showModal && (
        <Dropdown onToggle={(e, meta) => toggleHandler(e, meta)} show={show}>
          <Dropdown.Toggle
            id="dropdown-basic"
            variant="outline-secondary"
            className="filter-dropdown-toggle d-flex justify-content-flex-start align-items-center gap-6 position-relative"
          >
            <BsFilter className="me-2" /> Filter {!!filtersCount && `(${filtersCount})`}{' '}
            <BsChevronDown className="filter-dropdown-toggle-indicator" />
          </Dropdown.Toggle>

          <Dropdown.Menu className="connection-requests-filters--menu">
            <div className="p-3 connection-requests-filters--menu-wrapper">{children}</div>
            <Dropdown.Divider />
            <Row>
              <Col>
                {showClearButton && (
                  <Button variant="outline-primary" className="ms-3 me-2" onClick={clearHandler}>
                    Clear All
                  </Button>
                )}
              </Col>
              <Col xs="auto">
                <Button
                  className="me-3"
                  variant="primary"
                  onClick={applyHandler}
                  disabled={!isDirty}
                >
                  Apply
                </Button>
              </Col>
            </Row>
          </Dropdown.Menu>
        </Dropdown>
      )}

      {showModal && (
        <>
          <Button
            className="filter-dropdown-toggle d-flex justify-content-flex-start align-items-center gap-6 position-relative"
            variant="outline-secondary"
            onClick={() => setShow(true)}
          >
            <BsFilter className="me-2" /> Filter{' '}
            <BsChevronDown className="filter-dropdown-toggle-indicator" />
          </Button>
          <MobileFilterDropDown
            show={show}
            isDirty={isDirty}
            onHide={onHideHandler}
            onClear={clearHandler}
          >
            {children}
          </MobileFilterDropDown>
        </>
      )}
    </>
  );
};
